/**
 * Console shell state: active tab, sidebar collapse, and appearance. The tab
 * union is the single source of truth consumed by the routes registry.
 */

import { defineStore } from './createStore'

export type TabId = 'assets' | 'knowledge' | 'inbox' | 'messages' | 'more' | 'hardware' | 'health'

export type UiState = {
  activeTab: TabId
  sidebarCollapsed: boolean
  dark: boolean
}

export const uiStore = defineStore({
  init: (): UiState => ({
    activeTab: 'assets',
    sidebarCollapsed: false,
    dark: true,
  }),
  persist: 'unified-console.ui',
  actions: {
    selectTab(draft, tab: TabId) { draft.activeTab = tab },
    toggleSidebar(draft) { draft.sidebarCollapsed = !draft.sidebarCollapsed },
    setDark(draft, dark: boolean) { draft.dark = dark },
    toggleDark(draft) { draft.dark = !draft.dark },
  },
})

export const useUiStore = uiStore.useStore
